"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PASSWORD_REGEX = void 0;
var PASSWORD_REGEX = /^(?=.*[A-Z])(?=.*\d)(?=.*([^\w]?))([\S.]){8,40}$/;
exports.PASSWORD_REGEX = PASSWORD_REGEX;